var productWizardConstants = require('../Helpers/productWizardConstants');

module.exports = ['$scope', '$state', '$stateParams', '$anchorScroll', function ($scope, $state, $stateParams, $anchorScroll) {
    var activeColors = [];

    if (typeof ($stateParams.colors) === 'string') {
        activeColors = $stateParams.colors.split(',');
    }

    $scope.colorOptions = productWizardConstants.primaryColors;

    $scope.toggleColor = function ($event, color) {
        var orderedActiveColors = [];

        $event.preventDefault();
        if (activeColors.indexOf(color) === -1) {
            activeColors.push(color);
        } else {
            activeColors.splice(activeColors.indexOf(color), 1);
        }

        angular.forEach(productWizardConstants.primaryColors, function (color) {
            if (activeColors.indexOf(color.id) !== -1) {
                orderedActiveColors.push(color.id);
            }
        });

        $state.go('color', { colors: orderedActiveColors.join(',') });
    };

    $scope.getColorStatus = function (color) {
        if (activeColors.indexOf(color) !== -1) {
            return 'like active';
        } else {
            return 'like';
        }
    };

    $scope.btnShowStoneTypeClass = function () {
        if (activeColors.length > 0)
            return 'active';
        return 'disabled';
    };

    $scope.btnNotSureClick = function ($event) {
        $event.preventDefault();
        $state.go('style');
        $anchorScroll();
    };

    $scope.btnShowStoneTypeClick = function ($event) {
        $event.preventDefault();
        if (activeColors.length > 0)
            $state.go('stone-type', { colors: activeColors.join(',') });
        $anchorScroll();
    };

}];
